// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/RequesterTextField/RequesterTextFieldContextMenu/index.tsx

import { Box } from '@modusign/design-system';
import { FontType, TextAlign } from '@modusign/react-signing/types';

import {
  ContextMenuGroup,
  ContextMenuRow,
  ContextMenuRowDivider,
  ContextMenuWrapper,
} from '@app/components/ContextMenu';
import DataLabelInput from '@app/components/DataLabelInput';
import ContextMenuSelect from '@app/features/apply-react-signing/components/FieldSetupStep/ContextMenuSelect';
import ContextMenuTextAlignRow from '@app/features/apply-react-signing/components/FieldSetupStep/ContextMenuTextAlignRow';
import { FONT_SIZE_POINTS } from '@app/features/apply-react-signing/libs/hooks/useFontPixelSizes';

const FONT_POINT_OPTIONS = FONT_SIZE_POINTS.map((size) => ({
  value: size,
  displayText: `${size}pt`,
}));
const FONT_TYPES_MAP = [
  {
    value: 'NOTO_SANS',
    displayText: '본고딕',
  },
  {
    value: 'NOTO_SERIF',
    displayText: '본명조',
  },
];

interface RequesterTextFieldContextMenuProps {
  dataLabel: string;
  fontType: FontType;
  fontSize: number;
  dataLabelErrorMessage: string;
  isDataLabelEditable: boolean;
  textAlign: TextAlign;
  onChangeDataLabel: (dataLabel: string) => void;
  onChangeFontType: (fontType: FontType) => void;
  onChangeFontSize: (fontSize: number) => void;
  onChangeTextAlign: (textAlign: TextAlign) => void;
}

const defaultProps: Partial<RequesterTextFieldContextMenuProps> = {
  dataLabel: '',
  isDataLabelEditable: false,
  textAlign: 'LEFT',
};

function RequesterTextFieldContextMenu({
  dataLabel,
  fontType,
  fontSize,
  dataLabelErrorMessage,
  isDataLabelEditable,
  textAlign,
  onChangeDataLabel,
  onChangeFontType,
  onChangeFontSize,
  onChangeTextAlign,
}: RequesterTextFieldContextMenuProps) {
  return (
    <Box
      sx={{ left: '50%', position: 'absolute', top: '-22px', transform: 'translate(-50%, -100%)' }}
    >
      <ContextMenuWrapper>
        <ContextMenuRow>
          <ContextMenuGroup>
            <ContextMenuSelect
              ariaLabel="font-size"
              menuName="글자 크기"
              options={FONT_POINT_OPTIONS}
              selectBoxProps={{
                width: '84px',
              }}
              selectedOptionIndex={FONT_POINT_OPTIONS.findIndex(
                (option) => option.value === fontSize
              )}
              onOptionChange={({ value }) => onChangeFontSize(parseInt(`${value}`, 10))}
            />
            <ContextMenuSelect
              ariaLabel="font-family"
              menuName="글자체"
              options={FONT_TYPES_MAP}
              selectBoxProps={{
                width: '84px',
              }}
              selectedOptionIndex={FONT_TYPES_MAP.findIndex((option) => option.value === fontType)}
              onOptionChange={({ value }) => onChangeFontType(value as FontType)}
            />
            <ContextMenuTextAlignRow
              selectedTextAlign={textAlign}
              onChange={(textAlign) => onChangeTextAlign(textAlign)}
            />
          </ContextMenuGroup>
        </ContextMenuRow>
        {isDataLabelEditable && (
          <>
            <ContextMenuRowDivider />
            <Box
              sx={{
                padding: '10px 0 20px 0',
                position: 'relative',
                textAlign: 'left',
              }}
            >
              <DataLabelInput
                errorMessage={dataLabelErrorMessage}
                value={dataLabel}
                onChange={onChangeDataLabel}
              />
            </Box>
          </>
        )}
      </ContextMenuWrapper>
    </Box>
  );
}

RequesterTextFieldContextMenu.defaultProps = defaultProps;

export default RequesterTextFieldContextMenu;
